/**
 * Progetto AI Lab — reserved workspace for pilots, PoCs, experiments.
 * Source: Marko spec §6. coreBOS-A: new module; reserved-area RBAC is native.
 *
 * `membri_abilitati` defines RBAC access — only they can see the project.
 * `sistemi_ai_coinvolti` is a multi-ref (modeled as json until Flywheel supports multi-relation).
 * States: Proposto → In corso → (Sospeso) → Concluso → Promosso a produzione
 *   (Promosso typically spawns a Richiesta AI to formalize the system).
 */
export const aiLabProjectDescriptor = {
    slug: 'ai_lab_project',
    kind: 'document',
    label: { singular: 'Progetto AI Lab', plural: 'Progetti AI Lab' },
    table: 'ai_portal_ai_lab_project',
    idStrategy: 'sha256',
    fields: [
        { name: 'nome_progetto', type: 'text', label: 'Nome progetto', required: true },
        { name: 'tipo', type: 'text', label: 'Tipo', required: true },
        // Pilota | Assessment | PoC | Sperimentazione
        { name: 'stato_avanzamento', type: 'text', label: 'Stato avanzamento', required: true },
        // Proposto | In corso | Sospeso | Concluso | Promosso a produzione
        { name: 'categoria_rischio', type: 'text', label: 'Categoria di rischio', required: true },
        // Inaccettabile | Alto | Limitato | Minimo
        // multi-ref to ai_system — stored as json array of ids pending multi-relation support
        { name: 'sistemi_ai_coinvolti', type: 'json', label: 'Sistemi AI coinvolti' },
        // multi-ref to ai_user (defines RBAC access) — stored as json array
        { name: 'membri_abilitati', type: 'json', label: 'Membri abilitati', required: true },
    ],
    relations: [
        { name: 'responsabile', kind: 'belongsTo', target: 'ai_user' },
    ],
    behaviors: {
        ownership: true,
        audit: true,
        documents: true, // documentazione riservata
        tenantScoped: true,
    },
    emits: ['ai_lab_project.created', 'ai_lab_project.promoted'],
    ui: { mode: 'generated', icon: 'ExperimentOutlined', navGroup: 'Ricerca', navOrder: 20 },
};
